import { useI18N } from "common/hooks";
import { PlusCircleIcon } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

/**
 * "Add photos — Mobile app only". Contributing photos only exists in the app,
 * so on desktop this is a signpost rather than a control: it renders as inert
 * markup, which also keeps it legal inside the space card's content button.
 */
export default function AddPhotosCta({ className }: { className?: string }) {
  const i18n = useI18N();

  return (
    <div
      className={cn(
        // py-2.5 keeps the row at Figma's 48px once the 26px badge is inside.
        "flex items-center gap-3 rounded-lg border border-border-token-brand-minimal bg-bg-brand-secondary-default px-3 py-2.5",
        className,
      )}
    >
      <PlusCircleIcon
        size={20}
        aria-hidden="true"
        className="text-fg-neutral-strong shrink-0"
      />
      <span className="label-m-medium text-fg-neutral-strong">
        {i18n.get("addPhotos")}
      </span>
      {/* Same badge as the Contribute layer's mobile-only rows — keep the two
          in step if either changes. */}
      <span className="ml-auto shrink-0 whitespace-nowrap rounded-full border border-border-token-brand-subtle bg-container-brand-minimal px-2.5 py-1 label-s-medium text-fg-neutral-strong">
        {i18n.get("mobileAppOnly")}
      </span>
    </div>
  );
}
